<script>
import Icon from './Icon.vue';

const defaultBars = [
  100, 70, 45, 100, 70, 45, 45, 70, 100, 45, 70, 45, 75, 50, 45, 30, 30, 20,
];


export default {
  components: {
    Icon
  },
  props: {
    speak: String,
    withBars: {
      type: Boolean,
      required: false,
      default: true,
    }
  },

  name: 'TextToSpeech',

  data() {
    return {
      extended: false,
      state: 'notplaying',
      tts: window.speechSynthesis,
      spoken: [],
      intervalId: null,
      bars: defaultBars,
    }
  },

  computed: {
    boundaries() {
      return this.speak.split(" ");
    },

    spokenPercentage() {
      return (this.spoken.length * 100) / this.boundaries.length;

    },

    boundariesSupported() {
      return (
        this.tts.getVoices().filter(({ localService }) => localService).length > 0
      );
    },

    utter() {
      const _utter = new SpeechSynthesisUtterance(this.speak);
      _utter.onboundary = (event) => {
        if (event.name !== "word") return;
        const [start, end] = [
          event.charIndex,
          event.charIndex + event.charLength,
        ];
        const word = this.speak.slice(start, end);
        this.spoken.push(word);
      };
      _utter.onend = () => {
        this.spoken = [];
        this.state = "notplaying";
        clearInterval(this.intervalId);
        this.bars = defaultBars;
      };
      _utter.onstart = () => {
        this.state = "playing";
        this.intervalId = setInterval(this.animateBars, 100);
      };
      return _utter;
    },
  },

  methods: {
    play() {
      console.log(this.state);
      if (this.state === "playing") {
        this.state = "paused";
        this.tts.pause();
        return;
      }

      if (this.state === "paused") {
        this.state = "playing";
        this.tts.resume();
        return;
      }

      this.tts.speak(this.utter);
    },

    waveFormColor(n) {
      if (!this.boundariesSupported) {
        if (this.state !== "notplaying") {
          return "bg-teal-600";
        }
      }
      const currentWave = (n * 100) / 18;

      if (currentWave <= this.spokenPercentage) {
        return "bg-teal-600";
      }
      return "bg-indigo-600 bg-opacity-50";
    },

    boundedRandom() {
      return Math.random() * 80 + 20;
    },

    animateBars() {
      this.bars = this.bars.map(() => {
        return this.boundedRandom();
      });
    },

    extendAndPlay() {
      this.extended = true;
      this.play();
    },
  }
}
</script>
<template>
  <button
    :class="[
      'text-gray-900',
      'text-md',
      'border border-indigo-200',
      'bg-white hover:bg-indigo-50 focus:bg-indigo-50',
      'h-12',
      'rounded-xl',
      'px-4 py-3',
      'gap-2',
    ]"
    class="font-medium items-center inline-flex"
    @click.stop.prevent="extendAndPlay"
    @keydown.enter.stop.prevent="extendAndPlay"
    @keydown.space.stop.prevent="extendAndPlay"
    v-if="!extended"
    :aria-expanded="extended"
    title="Synthèse vocale"
  >
    <span class="relative">
      <Icon
        name="volume-high"
        class="fill-indigo-600 h-5 w-5"
        :aria-hidden="true"
      >
      </Icon>
    </span>
    <span class="md:hidden text-sm" v-if="!$isMobile">Écouter la question</span>
  </button>

  <div v-else class="relative flex items-center" :class="[
      'border border-indigo-200',
      'bg-white hover:bg-indigo-50 focus:bg-indigo-50', 'rounded-xl',
      'px-4 py-3',
      'gap-2']">
    <div
      v-if="withBars"
      class="absolute top-0 right-0 h-5 transform translate-x-1/2 -translate-y-1/2"
    >
      <button
        @click.stop.prevent="extended = false"
        @keydown.enter.stop.prevent="extended = false"
        @keydown.space.stop.prevent="extended = false"
        :class="[
          'text-gray-900',
          'text-md',
          'border border-indigo-100',
          'bg-white hover:bg-indigo-50 focus:bg-indigo-50',
          'h-5 w-5',
          'rounded-full',
          'p-1',
        ]"
        aria-label="Fermer"
      >
          <Icon name="close" class="fill-white text-red-700"></Icon>
      </button>
    </div>
    <button
      :title="
        state === 'notplaying' || state === 'paused' ? 'Lecture' : 'Pause'
      "
      :class="[
        'text-gray-900',
        'text-md',
        'bg-white hover:bg-indigo-50 focus:bg-indigo-50',
        'h-5',
        'rounded-full',
        'gap-2',
      ]"
      class="font-medium items-center inline-flex"
      @click.stop.prevent="play"
      @keydown.enter.stop.prevent="play"
      @keydown.space.stop.prevent="play"
    >
      <span class="relative">
        <Icon class="h-5 w-5" name="hourglass" v-if="state === 'playing'"></Icon>
        <Icon class="h-5 w-5" name="play-circle" v-else></Icon>
      </span>
      <span
        v-if="withBars"
        class="flex gap-1.5 h-full items-center">
        <span
          v-for="n in 18"
          :key="n"
          class="w-1 rounded-md text-xs transition-all duration-100"
          :class="`${waveFormColor(n)}`"
          :style="`height: ${bars[n - 1]}%`"
        ></span>
      </span>
    </button>
  </div>
</template>
